import React, { useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../../css/Experiencia.css";

const Experiencia = ({ theme = "ltm" }) => {
    const [loaded, setLoaded] = useState({
        img1: false,
        img2: false,
        img3: false,
    });

    const handleImageLoad = (imgKey) => {
        setLoaded((prev) => ({ ...prev, [imgKey]: true }));
    };

    // Animation refs
    const { ref: titleRef, inView: titleInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: leftColRef, inView: leftColInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: rightColRef, inView: rightColInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: buttonRef, inView: buttonInView } = useInView({ threshold: 0.1, triggerOnce: true });

    const scrollToSection = (id) => {
        const section = document.querySelector(id);
        if (section) {
            const navbar = document.querySelector('.navbar');
            const offset = navbar ? navbar.offsetHeight : 0; // Obtiene el tamaño del navbar segun el dispositivo
            const sectionPosition = section.offsetTop - offset; // hace offset segun el tamaño del navbar

            window.scrollTo({
                top: sectionPosition,
                behavior: 'smooth',
            });
        }
    };


    return (
        <div id="container-experiencia" className={`${theme}-fondo-crema`}>
            <h1
                ref={titleRef}
                className={`${theme}-titulo-experiencia pt-4 pb-4 pb-md-5 text-center experiencia-appear ${titleInView ? "experiencia-show" : ""}`}
            >
                LA EXPERIENCIA
            </h1>

            <div>
                <Row>
                    <Col
                        md={6}
                        ref={leftColRef}
                        className={`experiencia-appear ${leftColInView ? "experiencia-show experiencia-delay-1" : ""}`}
                    >
                        <h2 className="mx-4 mx-md-5 mb-4 mb-md-4 fw-bold">Una salida completa</h2>
                        <ul className="mx-3 mx-md-5 ltm-bullet-list">
                            <li>Bingo tradicional</li>
                            <li>Slots con pozos progresivos altísimos</li>
                            <li>Ruletas electrónicas</li>
                            <li>Shows, sorteos y promos</li>
                            <li>Propuesta gastronómica y barra</li>
                            <li>Sector al aire libre</li>
                        </ul>
                        <Button className={`${theme}-btn-outline-light ${theme}-btn-hero btn-lg mx-5 mt-5 mb-5 d-none d-md-inline-block`} onClick={() => scrollToSection('#redes')}>
                            Seguínos y enterate de todo al instante <i className="bi bi-arrow-right"></i>
                        </Button>
                    </Col>

                    <Col
                        md={6}
                        ref={rightColRef}
                        className={`px-5 pb-4 pb-md-5 experiencia-appear ${rightColInView ? "experiencia-show experiencia-delay-2" : ""
                            }`}
                    >
                        <Row className="d-flex" style={{ minHeight: "100%" }}>
                            <Col xs={6} className="d-flex flex-column" style={{ minHeight: "100%" }}>
                                {!loaded.img1 && <Skeleton height="clamp(20vh, 40vh, 40vh)" width="100%" />}
                                <img
                                    src="/imagenes/Fotos/foto 2 web - bolillas 800 x 800.jpeg"
                                    alt="Bolillas"
                                    className="img-fluid mb-2"
                                    style={{
                                        objectFit: "cover",
                                        height: "50%",
                                        display: loaded.img1 ? "block" : "none",
                                    }}
                                    onLoad={() => handleImageLoad("img1")}
                                />

                                {!loaded.img2 && <Skeleton height="clamp(20vh, 40vh, 40vh)" width="100%" />}
                                <img
                                    src="/imagenes/Fotos/fotobrindis.jpeg"
                                    alt="Bebidas"
                                    className="img-fluid"
                                    style={{
                                        objectFit: "cover",
                                        height: "50%",
                                        display: loaded.img2 ? "block" : "none",
                                    }}
                                    onLoad={() => handleImageLoad("img2")}
                                />
                            </Col>

                            <Col xs={6} className="d-flex flex-column justify-content-between ps-0" style={{ minHeight: "100%" }}>
                                {!loaded.img3 && <Skeleton height="clamp(80vh, 80vh, 80vh)" width="100%" />}
                                <img
                                    src="/imagenes/Fotos/foto 4 web - slots y cielo.jpg"
                                    alt="Slots"
                                    className="img-fluid"
                                    style={{
                                        objectFit: "cover",
                                        flexGrow: 1,
                                        display: loaded.img3 ? "block" : "none",
                                    }}
                                    onLoad={() => handleImageLoad("img3")}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>

            <div ref={buttonRef} className={`d-md-none text-center mx-4 pb-3 experiencia-transition-element experiencia-delay-4 ${buttonInView ? 'animate-in' : ''} `}>
                <Button className={`${theme}-btn-outline-light ${theme}-btn-hero btn-lg`} onClick={() => scrollToSection('#redes')}>
                    Seguínos y enterate de todo al instante<br/> <i className="bi bi-arrow-down"></i>
                </Button>
            </div>
        </div>
    );
};

export default Experiencia;
